import { useState } from 'react';
import { Modal, Button } from '@components/ui';
import { Wallet } from 'lucide-react';

export default function IncomeModal({ isOpen, onClose, onSubmit }) {
    const [formData, setFormData] = useState({
        amount: '',
        category: '',
        personName: '',
        apartmentNo: '',
        description: '',
        date: new Date().toISOString().split('T')[0],
    });

    const handleSubmit = () => {
        onSubmit?.(formData);
        setFormData({
            amount: '',
            category: '',
            personName: '',
            apartmentNo: '',
            description: '',
            date: new Date().toISOString().split('T')[0],
        });
        onClose();
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="💰 Gelir Ekle"
            size="md"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose}>İptal</Button>
                    <Button variant="success" onClick={handleSubmit}>Kaydet</Button>
                </>
            }
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">
                        Tutar (₺) *
                    </label>
                    <input
                        type="number"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary focus:border-primary focus:ring-2 focus:ring-primary/20 text-lg"
                        placeholder="0"
                        value={formData.amount}
                        onChange={(e) => handleChange('amount', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">
                        Kategori *
                    </label>
                    <select
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary focus:border-primary"
                        value={formData.category}
                        onChange={(e) => handleChange('category', e.target.value)}
                    >
                        <option value="">Seçiniz</option>
                        <option value="daire_satisi">Daire Satışı</option>
                        <option value="kapora">Kapora</option>
                        <option value="taksit">Taksit Ödemesi</option>
                        <option value="diger">Diğer Gelir</option>
                    </select>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">
                            Kişi / Firma
                        </label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary focus:border-primary"
                            placeholder="Ahmet Yılmaz"
                            value={formData.personName}
                            onChange={(e) => handleChange('personName', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">
                            Daire No
                        </label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary focus:border-primary"
                            placeholder="A-5"
                            value={formData.apartmentNo}
                            onChange={(e) => handleChange('apartmentNo', e.target.value)}
                        />
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">
                        Tarih
                    </label>
                    <input
                        type="date"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary focus:border-primary"
                        value={formData.date}
                        onChange={(e) => handleChange('date', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">
                        Açıklama
                    </label>
                    <textarea
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary focus:border-primary resize-none"
                        rows={2}
                        placeholder="Notlar..."
                        value={formData.description}
                        onChange={(e) => handleChange('description', e.target.value)}
                    />
                </div>
            </div>
        </Modal>
    );
}
